'use client'

import { FC } from 'react'

interface Props {
	className?: string
	ariaLabel?: string
}

/**
 * Animated loading dots indicator.
 * Displays 3 dots with staggered opacity animation.
 * Can be used for loading states in buttons, forms, etc.
 */
const LoadingDots: FC<Props> = ({ className = '', ariaLabel = 'Loading' }) => {
	return (
		<div
			className={`loading-dots ${className}`}
			role="status"
			aria-label={ariaLabel}
		>
			<span className="loading-dots__container" aria-hidden="true">
				<span className="loading-dots__dot" />
				<span className="loading-dots__dot" />
				<span className="loading-dots__dot" />
			</span>
		</div>
	)
}

export default LoadingDots
